import { AuthMultipleOnBehalfOfError } from './errors';
export function generateOnBehalfOfScope(id, type = 'cm_id') {
  if (!id) {
    return '';
  }
  return `on_behalf_of:${type}:${id}`;
}
export function extractResourceOwner(scope) {
  if (!scope) {
    return null;
  }
  const regexResults = scope.matchAll(/on_behalf_of:(\w+):(\w+)/g);
  const match = regexResults.next();
  // No match
  if (match.done) {
    return null;
  }
  // More than one match
  if (!regexResults.next().done) {
    throw new AuthMultipleOnBehalfOfError();
  }
  const type = match.value[1];
  const id = match.value[2];
  if (!type || !id) {
    return null;
  }
  return `${type}:${id}`;
}